import { createContext, useContext, useEffect, useState } from "react";

const BasketContext = createContext(null);

export function BasketProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kera_basket") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("kera_basket", JSON.stringify(items));
  }, [items]);

  const add = (p) =>
    setItems((cur) =>
      cur.find((i) => i.id === p.id)
        ? cur
        : [...cur, { id: p.id, name: p.name, image: p.image, category: p.category }]
    );
  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const has = (id) => items.some((i) => i.id === id);

  return (
    <BasketContext.Provider value={{ items, add, remove, clear, has, count: items.length }}>
      {children}
    </BasketContext.Provider>
  );
}

export const useBasket = () => useContext(BasketContext);
